var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6514 7.25977C19.7612 6.92204 20.2388 6.92204 20.3486 7.25977L22.8545 14.9717C23.0018 15.4247 23.424 15.7314 23.9004 15.7314H32.0088C32.3639 15.7314 32.5117 16.1857 32.2246 16.3945L25.665 21.1611C25.2795 21.4412 25.1174 21.9374 25.2646 22.3906L27.7705 30.1025C27.8798 30.4402 27.4933 30.7204 27.2061 30.5117L20.6465 25.7461C20.261 25.466 19.739 25.466 19.3535 25.7461L12.7939 30.5117C12.5067 30.7204 12.1202 30.4402 12.2295 30.1025L14.7354 22.3906C14.8826 21.9374 14.7205 21.4412 14.335 21.1611L7.77539 16.3945C7.48833 16.1857 7.63611 15.7314 7.99121 15.7314H16.0996C16.576 15.7314 16.9982 15.4247 17.1455 14.9717L19.6514 7.25977Z",
    stroke: "#FDB71A",
    strokeWidth: 0.733333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/star-outlined.7756f245b7e2c32c6be1841275f908bd.svg";
export { ForwardRef as ReactComponent };